import type { AssetBreadcrumbProps } from "./asset-breadcrumb.type";

import AncestorsBreadcrumb from "@/modules/ancestors/ancestors-breadcrumb";

const AssetBreadcrumb = ({ asset, ...options }: AssetBreadcrumbProps) => {
  return <AncestorsBreadcrumb {...options} ancestors={asset?.ancestors} />;
};

export default AssetBreadcrumb;
